import { render } from "./AuthContainer.vue?vue&type=template&id=1ce03078"
import script from "./AuthContainer.vue?vue&type=script&lang=js"
export * from "./AuthContainer.vue?vue&type=script&lang=js"

import exportComponent from "/home/developer/vezdevoz/per-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__